import React from 'react';
import PropTypes from 'prop-types';

const SvgText = ({
    backgroundColor,
    className,
    height,
    style,
    text = '',
    width,
}) => (
    <svg
        x-ms-format-detection="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        height={height}
        style={style}
        width={width}
    >
        <g>
            <rect fill={backgroundColor} height="100%" width="100%" x="0" y="0" />
            <text
                dominantBaseline="middle"
                fill="currentColor"
                textAnchor="middle"
                x="50%"
                y="50%"
            >
                {text}
            </text>
        </g>
    </svg>
);

SvgText.propTypes = {
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.string,
    style: PropTypes.object,
    text: PropTypes.string,
    width: PropTypes.string,
};

export default SvgText;
